/**
 * 文件下载工具方法
 */
export async function downloadFile(url, fileName) {
  return new Promise((resolve, reject) => {
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    // a.target = '_blank';
    document.body.appendChild(a);

    // 添加 click 事件监听器来确认点击是否成功
    a.addEventListener('click', () => {
      resolve();
    });

    // 如果 click 事件没有触发，或者浏览器不支持 download 属性
    a.addEventListener('error', (event) => {
      console.log('Error downloading file', event);
      
      event.preventDefault(); // 阻止默认行为
      reject(new Error('Failed to initiate download'));
    });

    a.click();
    document.body.removeChild(a);
  });
}

/**
 * 获取文件名
 * @param {String} url 文件链接地址
 * @param {String} title 标题（文件名）
 * @returns {String}
 */
export function getFileName(url, title) {
  const ex = getFileExtension(url);
  return ex ? `${title}.${ex}` : url;
}

/**
 * 获取文件后缀名
 * @param {String} fileName 文件名
 * @returns {String}
 */
export function getFileExtension(fileName) {
  return fileName.split('.').pop();
}

/**
 * 判断文件是否是图片
 * @param {String} fileName 文件名
 * @returns {Boolean}
 * @example
 * isImage('test.jpg') // true
 */
export function isImage(fileName) {
  return /\.(jpg|jpeg|png|gif|bmp|webp)$/.test(fileName);
}

/**
 * 判断文件是否是视频
 * @param {String} fileName 文件名
 * @returns {Boolean}
 * @example
 * isVideo('test.mp4') // true
 */
export function isVideo(fileName) {
  return /\.(mp4|avi|wmv|rmvb|mov|flv|mkv)$/.test(fileName);
}

/**
 * 判断文件是否是音频
 * @param {String} fileName 文件名
 * @returns {Boolean}
 * @example
 * isAudio('test.mp3') // true
 */
export function isAudio(fileName) {
  return /\.(mp3|wav|wma|ogg|flac)$/.test(fileName);
}

/**
 * 判断文件是否是文档
 * @param {String} fileName 文件名
 * @returns {Boolean}
 * @example
 * isDocument('test.pdf') // true
 */
export function isDocument(fileName) {
  return /\.(doc|docx|xls|xlsx|ppt|pptx|pdf)$/.test(fileName);
}

/**
 * 判断文件是否是压缩文件
 * @param {String} fileName 文件名
 * @returns {Boolean}
 * @example
 * isZip('test.zip') // true
 */
export function isZip(fileName) {
  return /\.(zip|rar|7z|tar|gz|bz2|xz)$/.test(fileName);
}

/**
 * 判断文件是否是PDF文件
 * @param {String} fileName 文件名
 * @returns {Boolean}
 * @example
 */
export function isPdf(fileName) {
  return /\.pdf$/.test(fileName);
}

/**
 * 判断文件是否是Word文件
 * @param {String} fileName 文件名
 * @returns {Boolean}
 * @example
 */
export function isWord(fileName) {
  return /\.(doc|docx)$/.test(fileName);
}

/**
 * 判断文件是否是Excel文件
 * @param {String} fileName 文件名
 * @returns {Boolean}
 * @example
 */
export function isExcel(fileName) {
  return /\.(xls|xlsx)$/.test(fileName);
}
